import Api from "@/api/index"

const Order = {
  namespaced: true,
  state: { //dado read only, e qm pode alterar esses dados são as mutations! VARIAVEIS
    oneOrder: null,
    allOrders: null,
    allInvoiceds: null,
    oneInvoiced: null,
    allPreInvoiceds: null,

    otherOrder: false,

    errorMessage: null,
    errorActive: null,

    updateOrderWasGood: null,
    updateOrderMessage: null,

    updateInvoicedError: null,
    updateInvoicedMsg: null,

    importWasGood: null,
    importMessage: null,

    updateRetryError: null,
    updateRetryMsg: null,
    
    allOrdersFake: null,
  },
  mutations: {// altera os dados do state
    clearAllOrders(state){
      state.allOrders = null
    },
    getOrders(state, orderA){
      state.allOrders = orderA; //orderA é o vehicles que veio da action
    },
    pushOrder(state, order){
      state.allOrders.push(order);
    },
    getOneOrder(state, order) {
      state.oneOrder = order;
    },
    updateOrder(state, {data, id}){
      state.allOrders.data[id] = data
    },
    updateWasGood(state, {was_good, msg}){
      state.updateOrderWasGood = was_good
      state.updateOrderMessage = msg
      setTimeout(() => {
        state.updateOrderWasGood = null
      }, 100);
    },

    getInvoiceds(state, invoices){
      state.allInvoiceds = invoices
    },
    getPreInvoiceds(state, pre_invoiceds){
      // state.allPreInvoiceds = pre_invoiceds
      state.allInvoiceds = pre_invoiceds
    },
    getOneInvoiced(state, invoiced){
      state.oneInvoiced = invoiced
    },
    pushInvoiced(state, invoiced){
      state.allInvoiceds.push(invoiced)
    },
    updateInvoiced(state, {invoiced, id}){
      if (state.allInvoiceds != null){
        state.allInvoiceds[id] = invoiced
      }
    },
    updateInvoicedStatus(state, {error, msg}){
      state.updateInvoicedError = error
      state.updateInvoicedMsg = msg
      setTimeout(() => {
        state.updateInvoicedError = null
      }, 200);
    },

    otherOrder(state, {value}){
      state.otherOrder = value
    },

    import_good(state, {msg, status}){
      state.importWasGood = status
      state.importMessage = msg
      setTimeout(() => {
        state.importWasGood = null
      }, 200);
    },

    clearOneOrder(state){
      state.oneOrder = null
    },
    clearOneInvoiced(state){
      state.oneInvoiced = null
    },
    clearInvoiceds(state){
      state.allInvoiceds = null
      state.allPreInvoiceds = null
    },

    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
      setTimeout(() => {
        state.errorActive = null;
      }, 50);
    },

    updateRetryError(state, {error, msg}){
      state.updateRetryError = error
      state.updateRetryMsg = msg
      setTimeout(() => {
      state.updateRetryError = null
      }, 200);
    },
  },
  actions: { //chamar o método dentro dos componentes
    clearAllOrders(context){
      context.commit('clearAllOrders')
    },
    index (context, order_status) {
      Api.Order.index(order_status)
        .then(response => response.data)
        .then(orders => {
          context.commit('getOrders', orders);
          // context.commit('setErrorMessage', {message: '',status: false});
        }).catch(function(error) {
          console.log(error);
        });
    },
    indexConcluded(context, {filter = null, params = {}}) {
      return Api.Order.indexConcluded(filter, params)
        .then(response => response.data)
        .then(orders => {
          if (orders.orders){
            context.commit('getOrders', orders.orders);
            context.commit('setErrorMessage', {message: '',status: false});
          } else {
            context.commit('getOrders', orders);
            context.commit('setErrorMessage', {message: '',status: false});
          }
          return orders
        }).catch(function(error) {
          console.log(error);
          throw Error(error)
        });
    },
    indexInvoiced (context, {obj}) {
      Api.Order.indexInvoiced(obj)
        .then(response => response.data)
        .then(invoices => {
          context.commit('getInvoiceds', invoices);
          // context.commit('setErrorMessage', {message: '',status: false});
        }).catch(function(error) {
          context.commit('setErrorMessage', {message: error.response.data.errors[0], status: true});
          console.log(error);
        });
    },
    indexPreInvoiced (context, {obj}) {
      Api.Order.indexPreInvoiced(obj)
        .then(response => response.data)
        .then(pre_invoiceds => {
          context.commit('getPreInvoiceds', pre_invoiceds);
          // context.commit('setErrorMessage', {message: '',status: false});
        }).catch(function(error) {
          context.commit('setErrorMessage', {message: error.response.data.errors[0], status: true});
          console.log(error);
        });
    },
    create(context, {newOrder, other}){
      if(!other){
        return Api.Order.create(newOrder)
          .then(response => response.data)
          .then(order => {
            // context.commitorderUpdate('pushOrder', {attributes: order});
            context.commit('setErrorMessage', {message: '', status: false});
            return order
          }).catch(function(error) {
            context.commit('setErrorMessage', {status: true, message: error.response.data.errors[0]})
            console.log(error);
            throw Error(error)
        });
      } else if (other){
        return Api.Order.createOther(newOrder)
          .then(response => response.data)
          .then(order => {
            // context.commit('pushOrder', {attributes: order});
            context.commit('setErrorMessage', {message: '', status: false});
            return order
          }).catch(function(error) {
            console.log(error);
            throw Error(error)
        });
      }
      
    },

    //FILE IMPORTING
    importInvoiced(context, {newInvoiced}){
      Api.Order.importFormData(newInvoiced)
        .then(response => response.data)
        .then(invoiced => {
          // context.commit('pushOrder', {attributes: order});
          setTimeout(() => {
            context.commit('import_good', {msg: invoiced, status: true});
            
          }, 1000);
        }).catch(function(error) {
          context.commit('import_good', {msg: 'Error', status: false});
          console.log(error)
        })
    },
    updateInvoiced_csv(context, {newInvoiced}){
      Api.Order.updateFormData(newInvoiced)
        .then(response => response.data)
        .then(invoiced => {
          // context.commit('pushOrder', {attributes: order});
          context.commit('import_good', {msg: invoiced, status: true});
        }).catch(function(error) {
          context.commit('import_good', {msg: 'Error', status: false});
          console.log(error);
        });
    },
    consolidateInvoiced(context, {newInvoiced}){
      Api.Order.consolidateFormData(newInvoiced)
        .then(response => response.data)
        .then(invoiced => {
          // context.commit('pushOrder', {attributes: order});
          context.commit('import_good', {msg: invoiced, status: true});
        }).catch(function(error) {
          context.commit('import_good', {msg: 'Error', status: false});
        });
    },
    // FILE IMPORTING


    createInvoiced(context, {newInvoiced}){
      Api.Order.createInvoiced(newInvoiced)
        .then(response => response.data)
        .then(invoiced => {
          // context.commit('pushOrder', {attributes: order});
          context.commit('setErrorMessage', {message: '', status: false});
        }).catch(function(error) {
          context.commit('setErrorMessage', {message: error.response.data.errors[0], status: true});
          console.log(error);
        });
    },
    updateInvoiced(context, {invoiced, id}){
      Api.Order.updateInvoiced(invoiced, id)
        .then(response => response.data)
        .then(invoiced =>{
          context.commit('updateInvoicedStatus', {error: false, msg: 'Atualizado com sucesso'})
          // context.commit('updateInvoiced', {invoiced: invoiced, id: id})
        }).catch(function (error){
          console.log(error);
          context.commit('updateInvoicedStatus', {error: true, msg: error.response.data.errors[0]})
        });
    },
    updateInvoicedKind(context, {kind, invoiced, id}){
      if (kind == 'info'){
        Api.Order.updateInvoicedInfo(invoiced, id)
          .then(response => response.data)
          .then(invoiced =>{
            context.commit('updateInvoicedStatus', {error: false, msg: 'Atualizado com sucesso'})
          }).catch(function (error){
            console.log(error);
            context.commit('updateInvoicedStatus', {error: true, msg: error.response.data.errors[0]})
          });
      } else if (kind == 'price'){
        Api.Order.updateInvoicedPrice(invoiced, id)
          .then(response => response.data)
          .then(invoiced =>{
            context.commit('updateInvoicedStatus', {error: false, msg: 'Atualizado com sucesso'})
          }).catch(function (error){
            console.log(error);
            context.commit('updateInvoicedStatus', {error: true, msg: error.response.data.errors[0]})
          });
      } else if (kind == 'nf'){
        Api.Order.updateInvoicedNF(invoiced, id)
          .then(response => response.data)
          .then(invoiced =>{
            context.commit('updateInvoicedStatus', {error: false, msg: 'Atualizado com sucesso'})
          }).catch(function (error){
            console.log(error);
            context.commit('updateInvoicedStatus', {error: true, msg: error.response.data.errors[0]})
          });
      }
    },
    showInvoiced(context, invoiced_id) {
      Api.Order.showInvoiced(invoiced_id)
        .then(response => response.data)
        .then(invoiced => {
          context.commit('getOneInvoiced', invoiced);
          context.commit('setErrorMessage', {message: '', status: false});
        }).catch(function(error) {
          console.log(error);
        });
    },


    show(context, {order_id}) {
      Api.Order.show(order_id)
        .then(response => response.data)
        .then(order => {
          context.commit('getOneOrder', order);
          context.commit('setErrorMessage', {message: '', status: false});
        }).catch(function(error) {
          console.log(error);
        });
    },


    update(context, {order, id, index, kind, damaged}){
      if (kind == 'normal'){
        return Api.Order.update(order, id)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - normal');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: index})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'approval'){
        return Api.Order.updateApproval(order, id)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - normal');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: 0})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'company-price'){
        return Api.Order.updateCompanyPrice(order, id)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - company-price');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: index})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'shipping'){
        return Api.Order.updateShipping(order, id)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - shipping');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: index})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'payment'){
        return Api.Order.updatePayment(order, id)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - payment');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: index})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'client'){
        return Api.Order.updateClient(order, id)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - client');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: index})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'item'){
        return Api.Order.updateItem(order, id, damaged)
        .then(response => response.data)
        .then(order => {
          // console.log('order updated - item product');
          // console.log(order);
          context.commit('updateWasGood', {was_good: true, msg: ''})
          context.commit('updateOrder', {data: order, id: index})
          //context.dispatch('show')
        }).catch(function(error) {
          console.log(error);
          context.commit('updateWasGood', {was_good: false, msg: error.response.data.errors[0]})
        });
      } else if (kind == 'retry'){
        return Api.Order.updateRetry(order, id)
        .then(response => response.data)
        .then(order => {
          console.log('order updated - RETRY');
          // console.log(order);
          // context.commit('updateOrder', {data: order, id: index})
          context.commit('updateRetryError',{error: false, msg: 'Atualizado com sucesso'})
        }).catch(function(error) {
          console.log(error);
          context.commit('updateRetryError',{error: true, msg: error.response.data.errors[0]})
        });
      }
    },





    
    other(context,{value}){
      context.commit('otherOrder', {value: value})
    },

    setFakes(context,fakes){
      context.commit('setFake', fakes)
    },
    updateFakes(context, {fake, id}){
      context.commit('updateFake', {fakeData: fake, id: id})
    },

    clearOneOrder(context){
      context.commit('clearOneOrder')
    },
    clearOneInvoiced(context){
      context.commit('clearOneInvoiced')
    },
    clearInvoiceds(context){
      context.commit('clearInvoiceds')
    },
  }
};

export default Order;